module.exports = __webpack_public_path__ + "images/24ba0b602d395f28e104ed941de18f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/cspa_logo_small.png
// module id = 1276
// module chunks = 0